<template>
    <label class="custom-file d-flex align-content-center justify-content-between">
        <input name="fileUpload" id="fileUpload" type="file" class="custom-file-input"
               accept=".doc,.docx,.pdf" @change="fileChanged" required
               style="pointer-events: none; position: absolute; width: 0">

        <span v-if="filename===''">Choose a file</span>
        <span v-else v-text="filename"></span>
        <span class="button m-0" style="font-size: .7em; line-height: .7">Upload file (.pdf, .docx)</span>
    </label>
</template>

<script>
    export default {
        data() {
            return {
                filename: ''
            }
        },
        methods: {
            fileChanged(e) {
                this.filename = e.target.files[0].name;
            }
        }
    }
</script>